import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { secureStorage, StorageKeys } from "@services/secureStorage.service";

interface ParentConfig {
  jwt: string;
  userId: string;
  clientId: string;
  appId: string;
  language?: string;
}

interface AuthState {
  jwt: string | null;
  userId: string | null;
  clientId: string | null;
  appId: string | null;
  isInitialized: boolean;
}

const initialState: AuthState = {
  jwt: null,
  userId: null,
  clientId: null,
  appId: null,
  isInitialized: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<ParentConfig>) => {
      state.jwt = action.payload.jwt;
      state.userId = action.payload.userId;
      state.clientId = action.payload.clientId;
      state.appId = action.payload.appId;
      state.isInitialized = true;
    },
    hydrateFromStorage: (state) => {
      const jwt = secureStorage.get<string>(StorageKeys.JWT);
      const userId = secureStorage.get<string>(StorageKeys.USER_ID);
      const clientId = secureStorage.get<string>(StorageKeys.CLIENT_ID);
      const appId = secureStorage.get<string>(StorageKeys.APP_ID);
      
      if (jwt && userId && clientId && appId) {
        state.jwt = jwt;
        state.userId = userId;
        state.clientId = clientId;
        state.appId = appId;
        state.isInitialized = true;
      }
    },
    clearCredentials: (state) => {
      state.jwt = null;
      state.userId = null;
      state.clientId = null;
      state.appId = null;
      state.isInitialized = false;
      secureStorage.clear();
    },
  },
});

export const { setCredentials, hydrateFromStorage, clearCredentials } = authSlice.actions;

// Selectors  
export const selectJwt = (state: any) => state.auth.jwt;
export const selectUserId = (state: any) => state.auth.userId;
export const selectClientId = (state: any) => state.auth.clientId;
export const selectAppId = (state: any) => state.auth.appId;
export const selectIsInitialized = (state: any) => state.auth.isInitialized;

export default authSlice.reducer;
